import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { styles } from "./QuotaDetails.styles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { formatPrice } from "../../../utilities/PriceUtils";
import { convertDateToFullDateTime, convertNumberToDateString } from "../../../utilities/dateTimeUtils";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";

export interface IQuotaDetailsProps extends WithStyles<typeof styles> {
    quota: any;
    isLoading?: boolean;
}

const QuotaDetailsPure: React.FunctionComponent<IQuotaDetailsProps> = ({ quota, isLoading }: IQuotaDetailsProps) => {
    return (
        <div>
            {isLoading ? (
                <CircularProgress />
            ) : (
                quota && (
                    <>
                        <Typography variant="caption" display="block">
                            Total Order Quota: {formatPrice(quota.totalAmount)}
                        </Typography>
                        <Typography variant="caption" display="block">
                            Used Order Quota: {formatPrice(quota.usedAmount)}
                        </Typography>
                        <Typography variant="caption" display="block">
                            Remaining Order Quota: {formatPrice(quota.remainingAmount)}
                        </Typography>
                        <Typography variant="caption" display="block">
                            Start Date: {convertNumberToDateString(quota.dateFrom)}
                        </Typography>
                        <Typography variant="caption" display="block">
                            End Date: {convertNumberToDateString(quota.dateTo)}
                        </Typography>
                        <Typography variant="caption" display="block">
                            Comment: {quota.comment}
                        </Typography>
                        <Typography variant="caption" display="block">
                            Created At: {convertDateToFullDateTime(quota.created)}
                        </Typography>
                    </>
                )
            )}
        </div>
    );
};

export const QuotaDetails = withStyles(styles)(QuotaDetailsPure);
